<div fxLayout="row" [fxLayoutAlign]="item.customField28" fxLayoutGap="15px">
    <button (click)="openInNewWindow(item.customField11)" [style.background-color]="item.customField18" mat-button [innerHTML]="item.title"></button>
    <button (click)="openInNewWindow1(item.customField17)" [style.background-color]="item.customField19" mat-button>{{item.customField16}}</button>
</div>